<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>
        <span>{{title}}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{iconname}}</mat-icon>
    </h1>
    <div class="centerwrap scroll" fxFlex.gt-sm="auto" fxFlex.lt-md="100">
        <div [innerHTML]="message | safeHTML"></div>
        <form [formGroup]="OptionsForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap.gt-sm="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <mat-form-field appearance="outline" *ngIf="ReportInfo.CanSetSchool">
                    <mat-select matInput formControlName="ReportSchool" aria-label="School selection list" placeholder="Select school...">
                        <mat-option [value]="null">Select school...</mat-option>
                        <mat-option *ngFor="let school of AvailableSchools" [value]="school">{{school.SchoolName}} ({{school.SchoolNumber}})</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-select matInput formControlName="ReportYear" aria-label="School year selection list" placeholder="Select year...">
                        <mat-option [value]="null">Select year...</mat-option>
                        <mat-option *ngFor="let year of AllSchoolYears" [value]="year">{{year | schoolYear}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" *ngIf="ReportInfo.CanSetJudgingPhase">
                    <mat-select matInput formControlName="ReportJudgingPhase" aria-label="Judging round selection list" placeholder="Select judging round...">
                        <mat-option [value]="null">Select judging round...</mat-option>
                        <mat-option *ngFor="let phase of AvailableWindowTypes" [value]="phase">{{phase.Description}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="center center" fxLayoutGap.lt-md="10px">
        <button mat-raised-button color="warn" (click)="CancelHandler()">{{canceltext}}</button>
        <button mat-raised-button color="primary" [disabled]="!OptionsForm.valid" (click)="OKHandler()">{{oktext}}</button>
    </div>
</div>
